import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Add, BeenhereRounded } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'period_date', width: 80 },
  { Header: 'Cód. Proveedor', accessor: 'pCardCode', width: 140 },
  { Header: 'Nombre Proveedor', accessor: 'pCardName' },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 130 },
  { Header: 'Nombre Cliente', accessor: 'CardName' },
  { Header: 'Cuota', accessor: 'quota', width: 130, excelEnabled: false },
  { Header: 'Cuota', accessor: 'quota_string', width: 0, hidden: true },
  { Header: 'Estado', accessor: 'state', width: 130 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotas, setCuotas] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [provider, setProvider] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index].quota = value;
    setCuotas([...cuotas]);
  };

  async function loadCuotas(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/customer-provider-quote', filter);
    setDataLoading(false);
    if (response.success) setCuotas(response.data);
  }

  async function updateCuota(id, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/customer-provider-quote', id, { quota: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCuotas(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <BeenhereRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => {
                  if ('id' in provider && 'period_date' in valueSearch) {
                    return setOpen({ ...provider, valueSearch });
                  }
                  return showNotify('Elija un periodo y proveedor', 'info');
                }}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de cuotas de proveedor {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadCuotas}
              getValueSearch={setValueSearch}
              getProvider={setProvider}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="period_date"
              provider
              providerFiled="base_provider_id"
              customer
            />

            <ReactTable
              excelName="cuotas_de_proveedor"
              formatDate="DD-MM-YYYY"
              defaultWidth={1200}
              columns={columns}
              data={cuotas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/customer-provider-quote"
                          id={item.id}
                          reload={() => loadCuotas(valueSearch)}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  period_date: item.period,
                  pCardCode: item.pCardCode,
                  pCardName: item.pCardName,
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  quota: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.quota}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="quota"
                        margin="normal"
                        value={item.quota || ''}
                        onChange={(e) => handleChange(item.id, e.target.value)}
                        onBlur={(e) => updateCuota(item.id, e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  quota_string: item.quota,
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
